exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detial-section {\r\n    background-color: #011526;\r\n    padding: 20px;\r\n    border-radius: 2px;\r\n    margin: 10px 0px;\r\n    opacity: 0.95;\r\n}\r\n\r\n#chart {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 10px;\r\n}\r\n\r\n.related-contianer{\r\n    float: left;\r\n    width: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/detial-view/detial-view.component.css
// module id = 309
// module chunks = 2